var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import SelectInput from '@shared/input/SelectInput';
import Tags from '@shared/tags/Tags';
import { useTagContext } from '@data/tag/tagContext';
function TagsEditWithDropdown(props) {
    var tags = props.tags, updateConnectedTagsWithNewArray = props.updateConnectedTagsWithNewArray;
    var parentIds = [];
    var orphants = [];
    var tagData = useTagContext().tagData;
    var renderOptions = [];
    tags.forEach(function (t, index) {
        var _a;
        var parentId = t.ParentId;
        if (parentId) {
            var options_1 = [];
            var parentTag = tagData.tagById[parentId];
            if (tagData.tagsByParentId[parentId]) {
                (_a = tagData.tagsByParentId[parentId]) === null || _a === void 0 ? void 0 : _a.forEach(function (tag) {
                    options_1.push({
                        label: "".concat(tag.name, " ").concat(tag.description ? tag.description : ''),
                        value: tag.id,
                    });
                });
                renderOptions.push(React.createElement(SelectInput, { key: '_' + index, label: parentTag === null || parentTag === void 0 ? void 0 : parentTag.name, name: parentTag === null || parentTag === void 0 ? void 0 : parentTag.name, searchable: true, options: options_1, placeholder: "Select tag", value: t.id, onChange: function (e) {
                        var connTags = __spreadArray([], __read(tags), false);
                        var targetIndex = 0;
                        tags.forEach(function (ct, index) {
                            if (ct.id === t.id) {
                                targetIndex = index;
                            }
                        });
                        var tag = tagData.tagById[e.target.value];
                        if (tag) {
                            connTags[targetIndex] = tag;
                        }
                        updateConnectedTagsWithNewArray(connTags);
                    } }));
            }
        }
        else {
            orphants.push(t);
        }
    });
    return (React.createElement("div", null,
        renderOptions,
        React.createElement("div", { style: { marginTop: '5px' } },
            React.createElement(Tags, { tags: orphants, canUpdate: false, remove: function () { }, select: function () { } }))));
}
export default TagsEditWithDropdown;
